import MenuBar from "../../MenuBar/MenuBar";

export default function Patty() {
    return (
        <>
            <text>Patty</text>
            <MenuBar page={"/"}/>
        </>
    )
}